import { PlusIcon } from 'lucide-react'
import { memo, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

import type { BillingBalance } from './billing.interface'
import { BillingBalanceDisplay } from './billing-balance-display.atom'

export interface BillingBalanceCardProps {
  balance: BillingBalance
  onTopUp?: () => void
  className?: string
}

const BillingBalanceCardBase: React.FC<BillingBalanceCardProps> = ({
  balance,
  onTopUp,
  className,
}): ReactNode => (
  <Card className={cn('billing-balance-card h-full', className)}>
    <CardHeader className="pb-2">
      <CardTitle className="text-base">Account Balance</CardTitle>
      <CardDescription>Available credits for AI usage</CardDescription>
    </CardHeader>
    <CardContent className="billing-balance-card-content flex flex-col gap-4">
      <div className="billing-balance-display-wrapper">
        <BillingBalanceDisplay amount={balance.amount} currency={balance.currency} size="lg" />
      </div>
      {onTopUp && (
        <Button className="billing-top-up-button w-full" onClick={onTopUp}>
          <PlusIcon className="mr-2 size-4" />
          Top up
        </Button>
      )}
    </CardContent>
  </Card>
)

export const BillingBalanceCard = memo(BillingBalanceCardBase)

BillingBalanceCard.displayName = 'BillingBalanceCard'
